import { StandardModal } from "@design-system/Modal/Modal";
import { useCallback, useState } from "react";
import { useViewOnlyRefusal } from "@hooks/permissions/useViewOnlyRefusal";
import { Button } from "@design-system/Button/Button";
import { Menu } from "@design-system/Menu/Menu.lib";
import { UploadIcon } from "@icons";
import styles from "./ImporterPage.module.scss";
import { ImporterPickExistingDocument } from "./ImporterPickExistingDocument";

interface Props {
    uploadNew: () => void;
}

export const ImporterUploadPrompt: React.FC<Props> = ({ uploadNew }) => {
    const [pickExistingDocument, setPickExistingDocument] = useState(false);
    const { refuseIfViewOnly } = useViewOnlyRefusal();

    // Both items lead somewhere the server cannot refuse in time: the OS file
    // dialog, and a picker whose selection writes to the importer queue
    // (PRO-11392).
    const handleUploadStatement = useCallback(() => {
        if (refuseIfViewOnly()) {
            return;
        }
        uploadNew();
    }, [refuseIfViewOnly, uploadNew]);

    const handleBrowseFromDocuments = useCallback(() => {
        if (refuseIfViewOnly()) {
            return;
        }
        setPickExistingDocument(true);
    }, [refuseIfViewOnly]);

    return (
        <>
            <Menu.Root
                side="top"
                trigger={
                    <Button
                        className={styles.uploadPrompt}
                        variant="primary"
                        size="md"
                        leftIcon={
                            <UploadIcon
                                className="icon-color-current"
                                width="12"
                                height="12"
                            />
                        }
                    >
                        Upload or drop in bank statements
                    </Button>
                }
            >
                <Menu.Item onClick={handleUploadStatement}>
                    Upload statement
                </Menu.Item>
                <Menu.Item onClick={handleBrowseFromDocuments}>
                    Browse from documents
                </Menu.Item>
            </Menu.Root>

            <StandardModal
                className="fullscreen-modal"
                contentClassName={styles.documentSelectModalContent}
                show={pickExistingDocument}
                onHide={() => setPickExistingDocument(false)}
            >
                <ImporterPickExistingDocument />
            </StandardModal>
        </>
    );
};
